import React, { Fragment } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Logo from '../../images/logo-01.png'
import Phone from '../../images/telephone.svg'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar';
import CursorMaus from '../../components/CursorMaus/CursorMaus';
import Footer from '../../components/footer/Footer'
import Contactpage from '../../components/Contactpage/Contactpage'

function Contact() {
  return (
    <div>

        <Fragment>

         <Navbar Logo={Logo} telephone={Phone} hclass={"wpo-site-header s3"} />
          <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'} />

        <Contactpage/>

  <Footer/>

        <Scrollbar/>
        <CursorMaus/>

        </Fragment>
      
    </div>
  )
}

export default Contact
